/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { profilesStore } from '../../axios/profilesStore'
import type {
	ProfilesStoreError,
	ProfilesStorePathParams,
	ProfilesStoreRequest,
	ProfilesStoreResponse,
} from '../../types/ProfilesStore'

export const profilesStoreMutationKey = () => [{ url: '/:organisation/profiles' }] as const

export type ProfilesStoreMutationKey = ReturnType<typeof profilesStoreMutationKey>

export type ProfilesStoreVariables = {
	organisation: ProfilesStorePathParams['organisation']
	data: ProfilesStoreRequest
}

/** @see backend/nexus/modules/Billing/Http/Controllers/ProfilesController.php ProfilesController::store */
export function useProfilesStore<TContext = unknown>(
	options?: UseMutationOptions<
		ProfilesStoreResponse,
		AxiosError<ProfilesStoreError>,
		ProfilesStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: profilesStoreMutationKey(),
		mutationFn: ({ organisation, data }: ProfilesStoreVariables) =>
			profilesStore(organisation, data, config).then(res => res.data),
		...options,
	})
}
